// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom[data-v-ce351a2e]{display:flex;width:100%;height:1.56rem;justify-content:center;align-items:center}.bottom button[data-v-ce351a2e]{width:6.9rem;height:.92rem;font-size:.32rem;font-weight:600;color:#fff;background:#fa3123;border-radius:.46rem;border:none;text-align:center}", ""]);
// Exports
module.exports = exports;
